import { render, staticRenderFns } from "./vipPrice.vue?vue&type=template&id=1537a53c&scoped=true&"
import script from "./vipPrice.vue?vue&type=script&lang=js&"
export * from "./vipPrice.vue?vue&type=script&lang=js&"
import style0 from "./vipPrice.vue?vue&type=style&index=0&id=1537a53c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537a53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1537a53c')) {
      api.createRecord('1537a53c', component.options)
    } else {
      api.reload('1537a53c', component.options)
    }
    module.hot.accept("./vipPrice.vue?vue&type=template&id=1537a53c&scoped=true&", function () {
      api.rerender('1537a53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/components/vipPrice.vue"
export default component.exports